import React, { useContext } from "react";
import BusinessContext from "context/BusinessContext";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import copy from "../../assets/images/icons8-copy-24.png";
import whatsapp from "../../assets/images/Icon simple-whatsapp.png";
import twitter from "../../assets/images/Icon feather-twitter.png";
import telegram from "../../assets/images/icons8-telegram-app-50.png";
import "./Product.scss";
const ModalShare = () => {
  const { shareLink, product } = useContext(BusinessContext);
  const popoverClickRootClose = (
    <Popover id="popover-trigger-click-root-close" title="Popover bottom">
      <div
        style={{
          fontWeight: "500",
          padding: "10px",
          color: "#586ba6",
        }}
      >
        کپی شد.
      </div>
    </Popover>
  );
  return (
    <div
      className="modal fade"
      id="ModalShare"
      tabIndex="-1"
      aria-labelledby="ModalShareLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modalShare">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="ModalShareLabel">
              اشتراک گذاری
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div
            className="modal-body"
            style={{ textAlign: "center", fontSize: "18px" }}
            dir="ltr"
          >
            {/* <div style={{ fontWeight: "500" }} dir="rtl">
              لینک اشتراک گذاری :
            </div> */}
            <div style={{ marginBottom: "15px" }}>
              <a
                href={`https://t.me/share/url?url=${shareLink}&text=${product.title}`}
                className="roundIcon"
                style={{
                  backgroundColor: "#29B6F6",
                }}
              >
                <img
                  src={telegram}
                  alt="telegram"
                  style={{ width: "36px", height: "36px", marginRight: "2px" }}
                />
              </a>
              <a
                href={`https://api.whatsapp.com/send/?text=${shareLink}&app_absent=0`}
                className="roundIcon"
                style={{ backgroundColor: "#56A689" }}
              >
                <img src={whatsapp} alt="whatsapp" />
              </a>
              <a
                href={`https://www.twitter.com/intent/tweet?url=${shareLink}&text=${product.title}`}
                className="roundIcon"
                style={{ backgroundColor: "#4B53F2" }}
              >
                <img src={twitter} alt="twitter" />
              </a>
            </div>
            <div
              style={{
                backgroundColor: "#8080801c",
                padding: "7px",
                borderRadius: "25px",
              }}
            >
              <span style={{ marginRight: "5px" }}>
                <img src={copy} alt="copy" />
              </span>
              <OverlayTrigger
                trigger="click"
                rootClose
                placement="bottom"
                overlay={popoverClickRootClose}
              >
                <a
                  style={{
                    color: "inherit",
                    textDecoration: "none",
                    cursor: "pointer",
                    lineBreak: "anywhere",
                    fontSize: "12px",
                  }}
                  onClick={(e) => navigator.clipboard.writeText(shareLink)}
                >
                  {shareLink}
                </a>
              </OverlayTrigger>
            </div>
            {/* <span>
              <img src={copy} alt="copy" />
            </span>
            <a
              style={{
                color: "inherit",
                textDecoration: "none",
                cursor: "pointer",
                lineBreak: "anywhere",
              }}
              onClick={(e) => navigator.clipboard.writeText(shareLink)}
            >
              {shareLink}
            </a> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalShare;
